/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject } from '@angular/core';
import { LineIsolationService } from './line-isolation.service';
import { LineIsolationListOverlayRef } from './line-isolation-list-overlay-ref';

@Component({
    selector: 'dash-gis-isolation-list',
    templateUrl: './line-isolation-list.component.html',
    styleUrls: [ './line-isolation-list.component.scss' ],
})
export class LineIsolationListComponent {

    constructor(
        private lineIsolationService: LineIsolationService,
        @Inject(LineIsolationListOverlayRef) private overlayRef,
    ) { }

    public close() {
        this.overlayRef.close();
    }

    public selectFeatures() {
        this.lineIsolationService.selectFeatures()
            .subscribe(() => {
                this.close();
            });
    }

    get selectedLine() {
        return this.lineIsolationService.hasIsolationData
            ? this.lineIsolationService.isolationData.selectedLine
            : [];
    }

    get isolatedNodes() {
        return this.lineIsolationService.hasIsolationData
            ? this.lineIsolationService.isolationData.nodes
            : [];
    }

    get isolatedLines() {
        return this.lineIsolationService.hasIsolationData
            ? this.lineIsolationService.isolationData.lines
            : [];
    }

}
